// Structured translation system. Add languages by adding a key here.
export const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'lv', label: 'LV' },
  { code: 'fr', label: 'FR' },
  { code: 'ru', label: 'RU' },
];

export const translations = {
  en: {
    // welcome
    experienceTitle: 'Champagne Tasting Experience',
    startExperience: 'Start the Experience',
    digitalBy: 'Digital experience by 0g Baltics',
    createdBy: 'Created by 0g Baltics',
    contactCta: "LET'S TALK ABOUT YOUR PROJECT",
    chooseLanguage: 'Choose your language',
    // nav
    nav_taste: 'Taste', nav_notes: 'My Notes', nav_challenge: 'Quiz',
    nav_discover: 'Discover', nav_reims: 'Reims', nav_order: 'Order',
    // taste
    taste_title: 'The Tasting', taste_intro: 'Six cuvées, in tasting order.',
    blend: 'Blend', yourRating: 'Your rating', aromas: 'Aromas I perceive',
    myImpressions: 'My impressions', notesPlaceholder: 'Write your personal tasting notes…',
    favourite: 'My Favourite', favourited: 'Your Favourite', bottlesToRequest: 'Bottles to request',
    privacyNote: 'Your personal tasting notes are stored on this device and browser. They remain available while your browser data is preserved.',
    prev: 'Previous', next: 'Next', cuvee: 'Cuvée',
    // aromas
    aroma_citrus: 'Citrus', aroma_white_fruit: 'White fruit', aroma_red_fruit: 'Red fruit',
    aroma_flowers: 'Flowers', aroma_brioche: 'Brioche', aroma_toasted: 'Toasted notes',
    aroma_spices: 'Spices', aroma_mineral: 'Mineral', aroma_honey: 'Honey', aroma_freshness: 'Freshness',
    // my notes
    notes_title: 'My Notes', notes_empty: 'Your tasting notes will appear here as you rate the champagnes.',
    noRating: 'Not rated yet', myFavouriteIs: 'My favourite of the evening',
    noFavourite: 'No favourite selected yet',
    // vote
    voteRecorded: 'Your favourite has been recorded', audienceFavourite: 'Audience Favourite',
    favouriteRemoved: 'Favourite removed', finishTasting: 'Finish · My Notes',
    moreAboutCuvee: 'More about this cuvée', officialHouseNotes: 'Maison Pommery — official notes', houseTastingNotes: 'Maison Pommery tasting notes',
    terroir: 'Terroir', crus: 'Crus', dosage: 'Dosage', ageing: 'Ageing', alcohol: 'Alcohol', reserveWine: 'Reserve wine',
    didYouKnow: 'Did you know?', dgroup_house: 'The House', dgroup_craft: 'Champagne & Savoir-Faire', dgroup_tonight: "Tonight's Experience",
    resultLater: 'The audience favourite will be revealed later tonight.',
    winningChampagne: 'Winning champagne', votes: 'votes',
    // challenge
    challenge_title: 'Champagne Challenge',
    challenge_intro: 'questions. Test your Champagne knowledge.',
    quizClosed: 'The Champagne Challenge is currently closed.',
    startChallenge: 'Start the Challenge', firstName: 'First name', lastName: 'Last name',
    email: 'Email', phone: 'Phone', question: 'Question', of: 'of',
    submitQuiz: 'Submit my answers', scoreRecorded: 'Your score has been recorded.',
    excellent: 'Excellent!', alreadyPlayed: 'You have already completed your official attempt.',
    yourScore: 'Your score', leaderboard: 'Leaderboard', rank: 'Rank', score: 'Score', time: 'Time',
    challengeWinner: 'Champagne Challenge Winner', beginQuiz: 'Begin', quizInfoNote: 'Used only to operate the competition.',
    congratulations: 'Congratulations!', tapToClose: 'Tap anywhere to continue',
    // discover
    discover_title: 'Discover', readMore: 'Read',
    // reims
    reims_default_cta: 'Discover Pommery in Reims',
    // order
    order_title: 'Bottle Request', order_intro: 'Select the cuvées and quantities you would like to request.',
    reviewRequest: 'Review request', yourDetails: 'Your details', fullName: 'Full name',
    optionalComment: 'Comment (optional)', sendRequest: 'Send my bottle request',
    orderEmptyError: 'Please select at least one bottle.', backToSelection: 'Back to selection',
    orderConfirmedTitle: 'Request recorded',
    orderConfirmed: 'Your request has been recorded successfully. We will contact you to confirm availability, price and collection/delivery arrangements. No payment is required at this stage.',
    noPaymentNote: 'No payment is required at this stage.', done: 'Done', bottles: 'bottles',
    // generic
    loading: 'Loading…', retry: 'Retry', errorGeneric: 'Something went wrong. Please try again.',
    connectionIssue: 'Connection issue. Please check your network.', save: 'Save', close: 'Close',
    requiredFields: 'Please fill in all required fields.',
  },
  lv: {
    experienceTitle: 'Šampanieša degustācijas pieredze',
    startExperience: 'Sākt pieredzi', digitalBy: 'Digitālā pieredze — 0g Baltics',
    createdBy: 'Izveidoja 0g Baltics', chooseLanguage: 'Izvēlieties valodu',
    contactCta: 'PARUNĀSIM PAR JŪSU PROJEKTU',
    nav_taste: 'Degustācija', nav_notes: 'Manas piezīmes', nav_challenge: 'Quiz',
    nav_discover: 'Atklāj', nav_reims: 'Reimsa', nav_order: 'Pasūtīt',
    taste_title: 'Degustācija', taste_intro: 'Sešas kuvē degustācijas secībā.',
    blend: 'Sastāvs', yourRating: 'Jūsu vērtējums', aromas: 'Aromāti, ko jūtu',
    myImpressions: 'Manas sajūtas', notesPlaceholder: 'Pierakstiet savas degustācijas piezīmes…',
    favourite: 'Mans favorīts', favourited: 'Jūsu favorīts', bottlesToRequest: 'Pieprasāmās pudeles',
    privacyNote: 'Jūsu personīgās degustācijas piezīmes tiek glabātas šajā ierīcē un pārlūkā. Tās paliek pieejamas, kamēr saglabāti pārlūka dati.',
    prev: 'Iepriekšējais', next: 'Nākamais', cuvee: 'Kuvē',
    aroma_citrus: 'Citrusi', aroma_white_fruit: 'Baltie augļi', aroma_red_fruit: 'Sarkanie augļi',
    aroma_flowers: 'Ziedi', aroma_brioche: 'Briošs', aroma_toasted: 'Grauzdētas notis',
    aroma_spices: 'Garšvielas', aroma_mineral: 'Minerāls', aroma_honey: 'Medus', aroma_freshness: 'Svaigums',
    notes_title: 'Manas piezīmes', notes_empty: 'Jūsu piezīmes parādīsies šeit, kad novērtēsiet šampaniešus.',
    noRating: 'Vēl nav novērtēts', myFavouriteIs: 'Mans vakara favorīts', noFavourite: 'Favorīts vēl nav izvēlēts',
    favouriteRemoved: 'Favorīts noņemts', finishTasting: 'Pabeigt · Manas piezīmes',
    moreAboutCuvee: 'Vairāk par šo kuvē', officialHouseNotes: 'Maison Pommery — oficiālas piezīmes', houseTastingNotes: 'Maison Pommery degustācijas piezīmes',
    terroir: 'Terruārs', crus: 'Cru ciemati', dosage: 'Dozējums', ageing: 'Nogatavināšana', alcohol: 'Alkohols', reserveWine: 'Rezerves vīns',
    didYouKnow: 'Vai zinājāt?', dgroup_house: 'Nams', dgroup_craft: 'Šampanietis un meistarība', dgroup_tonight: 'Šī vakara pieredze',
    voteRecorded: 'Jūsu favorīts ir reģistrēts', audienceFavourite: 'Publikas favorīts',
    resultLater: 'Publikas favorīts tiks atklāts vēlāk šovakar.',
    winningChampagne: 'Uzvarējušais šampanietis', votes: 'balsis',
    challenge_title: 'Šampanieša izaicinājums', challenge_intro: 'jautājumi. Pārbaudi savas zināšanas.',
    quizClosed: 'Šampanieša izaicinājums pašlaik ir slēgts.',
    startChallenge: 'Sākt izaicinājumu', firstName: 'Vārds', lastName: 'Uzvārds',
    email: 'E-pasts', phone: 'Tālrunis', question: 'Jautājums', of: 'no',
    submitQuiz: 'Iesniegt atbildes', scoreRecorded: 'Jūsu rezultāts ir reģistrēts.',
    excellent: 'Lieliski!', alreadyPlayed: 'Jūs jau esat pabeidzis oficiālo mēģinājumu.',
    yourScore: 'Jūsu rezultāts', leaderboard: 'Līderu saraksts', rank: 'Vieta', score: 'Rezultāts', time: 'Laiks',
    challengeWinner: 'Izaicinājuma uzvarētājs', beginQuiz: 'Sākt', quizInfoNote: 'Izmanto tikai konkursa vajadzībām.',
    congratulations: 'Apsveicam!', tapToClose: 'Pieskarieties, lai turpinātu',
    discover_title: 'Atklāj', readMore: 'Lasīt',
    reims_default_cta: 'Atklāj Pommery Reimsā',
    order_title: 'Pudeļu pieprasījums', order_intro: 'Izvēlieties kuvē un daudzumu, ko vēlaties pieprasīt.',
    reviewRequest: 'Pārskatīt pieprasījumu', yourDetails: 'Jūsu dati', fullName: 'Pilns vārds',
    optionalComment: 'Komentārs (neobligāti)', sendRequest: 'Nosūtīt pieprasījumu',
    orderEmptyError: 'Lūdzu, izvēlieties vismaz vienu pudeli.', backToSelection: 'Atpakaļ',
    orderConfirmedTitle: 'Pieprasījums reģistrēts',
    orderConfirmed: 'Jūsu pieprasījums ir veiksmīgi reģistrēts. Mēs ar jums sazināsimies, lai apstiprinātu pieejamību, cenu un saņemšanas/piegādes kārtību. Šajā posmā maksājums nav nepieciešams.',
    noPaymentNote: 'Šajā posmā maksājums nav nepieciešams.', done: 'Gatavs', bottles: 'pudeles',
    loading: 'Ielādē…', retry: 'Mēģināt vēlreiz', errorGeneric: 'Radās kļūda. Lūdzu, mēģiniet vēlreiz.',
    connectionIssue: 'Savienojuma problēma. Pārbaudiet tīklu.', save: 'Saglabāt', close: 'Aizvērt',
    requiredFields: 'Lūdzu, aizpildiet visus obligātos laukus.',
  },
  fr: {
    experienceTitle: 'Expérience de dégustation de Champagne',
    startExperience: "Commencer l'expérience", digitalBy: 'Expérience digitale par 0g Baltics',
    createdBy: 'Créé par 0g Baltics', chooseLanguage: 'Choisissez votre langue',
    contactCta: 'PARLONS DE VOTRE PROJET',
    nav_taste: 'Déguster', nav_notes: 'Mes notes', nav_challenge: 'Quiz',
    nav_discover: 'Découvrir', nav_reims: 'Reims', nav_order: 'Commander',
    taste_title: 'La dégustation', taste_intro: 'Six cuvées, dans l\'ordre de dégustation.',
    blend: 'Assemblage', yourRating: 'Votre note', aromas: 'Arômes que je perçois',
    myImpressions: 'Mes impressions', notesPlaceholder: 'Écrivez vos notes de dégustation…',
    favourite: 'Ma favorite', favourited: 'Votre favorite', bottlesToRequest: 'Bouteilles à demander',
    privacyNote: 'Vos notes de dégustation personnelles sont enregistrées sur cet appareil et ce navigateur. Elles restent disponibles tant que les données du navigateur sont conservées.',
    prev: 'Précédent', next: 'Suivant', cuvee: 'Cuvée',
    aroma_citrus: 'Agrumes', aroma_white_fruit: 'Fruits blancs', aroma_red_fruit: 'Fruits rouges',
    aroma_flowers: 'Fleurs', aroma_brioche: 'Brioche', aroma_toasted: 'Notes grillées',
    aroma_spices: 'Épices', aroma_mineral: 'Minéral', aroma_honey: 'Miel', aroma_freshness: 'Fraîcheur',
    notes_title: 'Mes notes', notes_empty: 'Vos notes apparaîtront ici au fur et à mesure de vos dégustations.',
    noRating: 'Pas encore noté', myFavouriteIs: 'Ma favorite de la soirée', noFavourite: 'Aucune favorite sélectionnée',
    voteRecorded: 'Votre favorite a été enregistrée', audienceFavourite: 'Favorite du public',
    favouriteRemoved: 'Favorite retirée', finishTasting: 'Terminer · Mes notes',
    moreAboutCuvee: 'En savoir plus sur cette cuvée', officialHouseNotes: 'Maison Pommery — notes officielles', houseTastingNotes: 'Notes de dégustation Maison Pommery',
    terroir: 'Terroir', crus: 'Crus', dosage: 'Dosage', ageing: 'Vieillissement', alcohol: 'Alcool', reserveWine: 'Vin de réserve',
    didYouKnow: 'Le saviez-vous ?', dgroup_house: 'La Maison', dgroup_craft: 'Champagne & Savoir-Faire', dgroup_tonight: "L'expérience de ce soir",
    resultLater: 'La favorite du public sera révélée plus tard ce soir.',
    winningChampagne: 'Champagne gagnant', votes: 'votes',
    challenge_title: 'Champagne Challenge', challenge_intro: 'questions. Testez vos connaissances.',
    quizClosed: 'Le Champagne Challenge est actuellement fermé.',
    startChallenge: 'Commencer le Challenge', firstName: 'Prénom', lastName: 'Nom',
    email: 'E-mail', phone: 'Téléphone', question: 'Question', of: 'sur',
    submitQuiz: 'Valider mes réponses', scoreRecorded: 'Votre score a été enregistré.',
    excellent: 'Excellent !', alreadyPlayed: 'Vous avez déjà terminé votre tentative officielle.',
    yourScore: 'Votre score', leaderboard: 'Classement', rank: 'Rang', score: 'Score', time: 'Temps',
    challengeWinner: 'Gagnant du Champagne Challenge', beginQuiz: 'Commencer', quizInfoNote: 'Utilisé uniquement pour le concours.',
    congratulations: 'Félicitations !', tapToClose: 'Touchez l\'écran pour continuer',
    discover_title: 'Découvrir', readMore: 'Lire',
    reims_default_cta: 'Découvrir Pommery à Reims',
    order_title: 'Demande de bouteilles', order_intro: 'Sélectionnez les cuvées et les quantités souhaitées.',
    reviewRequest: 'Vérifier la demande', yourDetails: 'Vos coordonnées', fullName: 'Nom complet',
    optionalComment: 'Commentaire (facultatif)', sendRequest: 'Envoyer ma demande',
    orderEmptyError: 'Veuillez sélectionner au moins une bouteille.', backToSelection: 'Retour',
    orderConfirmedTitle: 'Demande enregistrée',
    orderConfirmed: 'Votre demande a bien été enregistrée. Nous vous contacterons pour confirmer la disponibilité, le prix et les modalités de retrait/livraison. Aucun paiement n\'est requis à ce stade.',
    noPaymentNote: 'Aucun paiement n\'est requis à ce stade.', done: 'Terminé', bottles: 'bouteilles',
    loading: 'Chargement…', retry: 'Réessayer', errorGeneric: 'Une erreur est survenue. Veuillez réessayer.',
    connectionIssue: 'Problème de connexion. Vérifiez votre réseau.', save: 'Enregistrer', close: 'Fermer',
    requiredFields: 'Veuillez remplir tous les champs requis.',
  },
  ru: {
    experienceTitle: 'Дегустация шампанского',
    startExperience: 'Начать', digitalBy: 'Цифровой опыт от 0g Baltics',
    contactCta: 'ОБСУДИМ ВАШ ПРОЕКТ',
    createdBy: 'Создано 0g Baltics', chooseLanguage: 'Выберите язык',
    nav_taste: 'Дегустация', nav_notes: 'Мои заметки', nav_challenge: 'Квиз',
    nav_discover: 'Открыть', nav_reims: 'Реймс', nav_order: 'Заказ',
    taste_title: 'Дегустация', taste_intro: 'Шесть кюве в порядке дегустации.',
    blend: 'Состав', yourRating: 'Ваша оценка', aromas: 'Ароматы, которые я чувствую',
    myImpressions: 'Мои впечатления', notesPlaceholder: 'Запишите свои впечатления…',
    favourite: 'Моё любимое', favourited: 'Ваш фаворит', bottlesToRequest: 'Бутылки к заказу',
    privacyNote: 'Ваши личные заметки хранятся на этом устройстве и в этом браузере. Они доступны, пока сохраняются данные браузера.',
    prev: 'Назад', next: 'Далее', cuvee: 'Кюве',
    aroma_citrus: 'Цитрус', aroma_white_fruit: 'Белые фрукты', aroma_red_fruit: 'Красные фрукты',
    aroma_flowers: 'Цветы', aroma_brioche: 'Бриошь', aroma_toasted: 'Поджаренные ноты',
    aroma_spices: 'Специи', aroma_mineral: 'Минеральность', aroma_honey: 'Мёд', aroma_freshness: 'Свежесть',
    favouriteRemoved: 'Фаворит удалён', finishTasting: 'Завершить · Мои заметки',
    moreAboutCuvee: 'Подробнее об этой кюве', officialHouseNotes: 'Maison Pommery — официальные заметки', houseTastingNotes: 'Дегустационные заметки Maison Pommery',
    terroir: 'Терруар', crus: 'Крю', dosage: 'Дозаж', ageing: 'Выдержка', alcohol: 'Алкоголь', reserveWine: 'Резервное вино',
    didYouKnow: 'А вы знали?', dgroup_house: 'Дом', dgroup_craft: 'Шампанское и мастерство', dgroup_tonight: 'Впечатления вечера',
    notes_title: 'Мои заметки', notes_empty: 'Ваши заметки появятся здесь по мере дегустации.',
    noRating: 'Ещё не оценено', myFavouriteIs: 'Мой фаворит вечера', noFavourite: 'Фаворит ещё не выбран',
    voteRecorded: 'Ваш фаворит записан', audienceFavourite: 'Фаворит публики',
    resultLater: 'Фаворит публики будет объявлен позже вечером.',
    winningChampagne: 'Победившее шампанское', votes: 'голосов',
    challenge_title: 'Champagne Challenge', challenge_intro: 'вопросов. Проверьте свои знания.',
    quizClosed: 'Champagne Challenge сейчас закрыт.',
    startChallenge: 'Начать челлендж', firstName: 'Имя', lastName: 'Фамилия',
    email: 'Эл. почта', phone: 'Телефон', question: 'Вопрос', of: 'из',
    submitQuiz: 'Отправить ответы', scoreRecorded: 'Ваш результат записан.',
    excellent: 'Отлично!', alreadyPlayed: 'Вы уже прошли официальную попытку.',
    yourScore: 'Ваш результат', leaderboard: 'Таблица лидеров', rank: 'Место', score: 'Очки', time: 'Время',
    challengeWinner: 'Победитель Champagne Challenge', beginQuiz: 'Начать', quizInfoNote: 'Используется только для конкурса.',
    congratulations: 'Поздравляем!', tapToClose: 'Нажмите, чтобы продолжить',
    discover_title: 'Открыть', readMore: 'Читать',
    reims_default_cta: 'Открыть Pommery в Реймсе',
    order_title: 'Запрос бутылок', order_intro: 'Выберите кюве и количество для запроса.',
    reviewRequest: 'Проверить запрос', yourDetails: 'Ваши данные', fullName: 'Полное имя',
    optionalComment: 'Комментарий (необязательно)', sendRequest: 'Отправить запрос',
    orderEmptyError: 'Пожалуйста, выберите хотя бы одну бутылку.', backToSelection: 'Назад',
    orderConfirmedTitle: 'Запрос записан',
    orderConfirmed: 'Ваш запрос успешно записан. Мы свяжемся с вами, чтобы подтвердить наличие, цену и условия получения/доставки. Оплата на данном этапе не требуется.',
    noPaymentNote: 'Оплата на данном этапе не требуется.', done: 'Готово', bottles: 'бутылок',
    loading: 'Загрузка…', retry: 'Повторить', errorGeneric: 'Что-то пошло не так. Попробуйте снова.',
    connectionIssue: 'Проблема соединения. Проверьте сеть.', save: 'Сохранить', close: 'Закрыть',
    requiredFields: 'Пожалуйста, заполните все обязательные поля.',
  },
};
